import React, { useRef } from "react"
import RoleAccess from "../../Components/RoleAccess";
import { FullWidthCardTemplate, MediumCardTemplate, SmallCardTemplate } from "./ProductSummaryInsights";
import CustomOverlayPanel from './CustomOverlayComponent';
import { useNavigate, useLocation } from "react-router-dom";
import { useDateFormatter } from "../../Components/FormatDateTime";
import { CurrencyFormatter, useCurrencyConstants } from '../../Components/CurrencyFormatter';
import { getKindMenuItems, navigateToPlanWizard } from "../../constants/planWizardTypes";
import { getDateRange } from "../../Components/DateRange";

const DEFAULT_PAYMENTS_PERIOD = "this_month";

const ProductDetailCardInsights = (props) => {
      const { formatDate, formatApiDate } = useDateFormatter();
      const { currencyFormat, currencySymbol } = useCurrencyConstants();

      const op = useRef(null);
      const addPlanOp = useRef(null);
      const addPlanTriggerRef = useRef(null);
      const navigate = useNavigate();
      const location = useLocation();
      const planCreateReturnTo = `${location.pathname}${location.search}`;
      const planKindItems = getKindMenuItems(props.t);

      const alignAddPlanOverlayArrow = () => {
            requestAnimationFrame(() => {
                  const panel = addPlanOp.current?.getElement?.();
                  const target = addPlanTriggerRef.current;
                  if (!panel || !target) {
                        return;
                  }

                  const panelRect = panel.getBoundingClientRect();
                  const targetRect = target.getBoundingClientRect();
                  const arrowLeft = targetRect.left + (targetRect.width / 2) - panelRect.left;

                  panel.style.setProperty('--plan-kind-arrow-left', `${arrowLeft}px`);
            });
      };

      const createdOn = props.state.planGroup ? formatDate(props.state.planGroup.createdDate) : "";
      const updatedOn = props.state.planGroup ? formatDate(props.state.planGroup.lastModifiedDate) : "";

      const mainCardInfo = [
            {
                  page: "product-detail",
                  props,
                  createdOn,
                  updatedOn,

            }
      ]

      const productSummaryInfo = [
            {
                  title: props.t("products.number_subscription"), subDesc: <span className="productSummaryInfo">{props.t("subscriptions")}</span>,
                  value: props.state.performance.activeSubscriptionCount, cardInfo: props.t("summary_reports.active_subs_info")
            },
            {
                  title: props.t("products.number_subscriber"), subDesc: <span className="productSummaryInfo">{props.t("subscribers")}</span>,
                  value: props.state.performance.activeCustomerCount, cardInfo: props.t("products.active_subscribers_tooltip")
            },
            {
                  title: props.t("products.number_active"), subDesc: <span className="productSummaryInfo">{props.t("products.plans")}</span>,
                  value: props.state.performance.activeTierCount, cardInfo: props.t("products.active_plans_tooltip")
            },
      ]
      const invitationContent = [
            {
                  title: props.t("products.highest_subscription"), subDesc: props.state.performance.highestSubscriptionTierName,
                  value: props.state.performance.activeSubscriptionCount, cardInfo: props.t("products.highest_subs_info")
            },
            {
                  title: props.t("products.highest_revenue"),
                  cardInfo: props.t("products.highest_rev_info"),
                  subDesc: props.state.performance.highestRevenueTierName,
                  value: <CurrencyFormatter
                        amount={props.state.performance.collected}
                        currencySymbol={currencySymbol}
                        currencyFormat={currencyFormat}
                        symbolClass="collected-symbol"
                        valueClass="collected-value"
                  />
            }
      ]
      const productsDetailSnapshots = [
            {
                  type: "subs",
                  title: props.t("subscriptions"),
                  cardInfo: props.t("products.subs_info"),

                  subtitleNew: props.t("products.new"),
                  subsNewValue: props.state.performance?.newSubscriptionsCount,
                  subNewDesc: props.t("product.subscription"),
                  subsNewDesc: props.t("product.subscriptions"),

                  subtitleActive: props.t("products.active"),
                  subsActiveValue: props.state.performance?.activeSubscriptionCount,
                  subActiveDesc: props.t("product.subscription"),
                  subsActiveDesc: props.t("product.subscriptions"),

                  subtitleCompleted: props.t("products.completed"),
                  subsCompletedValue: props.state.performance?.completedSubscriptionCount,
                  subCompletedDesc: props.t("product.subscription"),
                  subsCompletedDesc: props.t("product.subscriptions"),

                  subtitlePaused: props.t("products.paused"),
                  subsPausedValue: props.state.performance?.pausedSubscriptionCount,
                  subPausedDesc: props.t("product.subscription"),
                  subsPausedDesc: props.t("product.subscriptions"),

                  subtitleCancelled: props.t("products.cancelled"),
                  subsCancelledValue: props.state.performance?.cancelledSubscriptionCount,
                  subCancelledDesc: props.t("product.subscription"),
                  subsCancelledDesc: props.t("product.subscriptions")
            },
            {
                  type: "payments",
                  title: props.t("common.payments"),
                  cardInfo: props.t("products.payments_info"),
                  collectedSubDesc: props.t("products.collected"),
                  collectedValue: <div className="flex-row">
                        <CurrencyFormatter
                              amount={props.state.performance.collected}
                              currencySymbol={currencySymbol}
                              currencyFormat={currencyFormat}
                              symbolClass="collected-symbol"
                              valueClass="collected-value"
                        />
                  </div>,
                  revenueSubDesc: props.t("products.revenue"),
                  revenueValue: <div className="flex-row">
                        <CurrencyFormatter
                              amount={props.state.performance.revenue}
                              currencySymbol={currencySymbol}
                              currencyFormat={currencyFormat}
                              symbolClass="revenue-symbol"
                              valueClass="revenue-value"
                        />
                  </div>,
                  missedSubDesc: props.t("products.missed"),
                  missedValue: <div className="flex-row">
                        <CurrencyFormatter
                              amount={props.state.performance.missed}
                              currencySymbol={currencySymbol}
                              currencyFormat={currencyFormat}
                              symbolClass="missed-symbol"
                              valueClass="missed-value"
                        />
                  </div>
            },

            //This (item)screen has been commented out for now but might be needed in the future
            // {
            //       type: "withdrawals",
            //       title: props.t("product_account.withdrawals"),
            //       cardInfo: props.t("products.withdrawals_info"),
            //       processedWithdrawalDesc: props.t("products.processed"),
            //       processedWithdrawalValue: <div className="flex-row"> <span className="currency">{props.defMembership.business?.currency}</span>&nbsp;
            //             <span className="card-values">{props.state.performance.approved?.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span></div>,
            //       pendingWithdrawalDesc: props.t("products.pending"),
            //       pendingWithdrawalValue: <div className="flex-row"> <span className="currency">{props.defMembership.business?.currency}</span>&nbsp;
            //             <span className="card-values">{props.state.performance.pending?.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span></div>,
            //       reversedWithdrawalDesc: props.t("products.reversed"),
            //       reversedWithdrawalValue: <div className="flex-row"> <span className="currency">{props.defMembership.business?.currency}</span>&nbsp;
            //             <span className="card-values">{props.state.performance.reversed?.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span></div>
            // }
      ]

      const sideMenu = [
            {
                  label: props.t("product.share_product"),
                  icon: "pi-share-alt",
                  onclick: () => { props.setSharePlanDialog(true) },
            },
            {
                  label: props.t("products.edit_product"),
                  icon: "pi-pencil",
                  onclick: () => { props.setProductInfoVisible(props.state.planGroup) },
            },
            {
                  label: props.t("products.archive_info"),
                  icon: "pi-lock",
                  onclick: () => { props.setArchive(true) },
            },
            {
                  label: props.t("products.add_product"),
                  icon: "pi-plus-circle",
                  hasSubmenu: true,
                  onclick: (e) => {
                        addPlanOp.current.toggle(e);
                  },
            },
             {
            label: props.t('products.share_leaderboard'),
            icon: "pi-crown",
            iconClass: props.state.planGroup?.boardUrl ? "leaderboard-active" : "leaderboard-inactive",
            onclick: () => {
                  if(props.state.planGroup.boardUrl){
                        props.planShare(); 
                  }
                  else{
                        // props.Leaderboard(props.state.planGroup.id)
                        props.toogleConfirmVisible()
                  }
                   
                  },
            
        },
            //This (item)screen has been commented out for now but might be needed in the future
            // {
            //       label: props.t("products.send_money"),
            //       icon: "layout-menuitem-icon pi pi-fw pi-send",
            //       onclick: () => {
            //             navigate("/money/send", { search: "walletId=" + props.planGroup.id })
            //       },
            // }
      ];

      const paymentSideMenu = [{
            paymentLabel: props.t("common.payments"),
            icon: "layout-menuitem-icon pi pi-fw pi-credit-card",
            ellipsisIcon: "p-button-icon p-c pi pi-ellipsis-v"
      }]

      const bottomSideMenu = [
            // {
            //       label: props.t("product_account.withdrawals"),
            //       icon: "layout-menuitem-icon pi pi-fw pi-list",
            //       onclick: () => {
            //             navigate("/money/product_accounts/withdrawalsList", { state: props.planGroup, search: "walletId=" + props.planGroup.id })
            //       }
            // },
            {
                  label: props.t("products.subs_report"),
                  icon: "layout-menuitem-icon pi pi-book",
                  onclick: () => {
                        navigate("/reports/subscription/custom", { state: props.planGroup });
                  }
            }
      ]

      const product = props.state?.planGroup || props.planGroup;
      const productId = product?.id;

      const redirectToPaymentsPage = (type) => {
            if (!productId) return;

            op.current?.hide?.();
            const { startDate, endDate } = getDateRange(DEFAULT_PAYMENTS_PERIOD, { returnRange: true });
            const params = new URLSearchParams();
            params.set('type', type);
            params.set('product', String(productId));
            if (startDate) params.set('startDate', formatApiDate(startDate));
            if (endDate) params.set('endDate', formatApiDate(endDate));

            navigate({
                  pathname: '/payments',
                  search: params.toString()
            }, {
                  state: {
                        prefillProduct: {
                              id: product.id,
                              name: product.name,
                        }
                  }
            });
      };

      const togglePaymentsMenu = (e) => {
            e.preventDefault();
            e.stopPropagation();
            op.current?.toggle(e);
      };

      return (
            <div className="grid nested-grid product-detail-layout">
                  <section className="col-12 xl:col-9 product-detail-main">
                        <div className="grid product-detail-header-grid">
                              <FullWidthCardTemplate summary={mainCardInfo} />
                        </div>

                        <p className="wallet-titles summary-title">{props.t("products.summary")}</p>

                        <div className="grid product-detail-stats-grid" id="summary-subscription-section">
                              <SmallCardTemplate header={props.t("products.summary")} summary={productSummaryInfo} loading={props.fetchingPerformance} />
                        </div>
                        <div className="grid product-detail-stats-grid" id="summary-subscription-section">
                              <SmallCardTemplate summary={invitationContent} loading={props.fetchingPerformance} />
                        </div>
                        <div className="grid product-detail-insights-grid" id="products-summary-section">
                              <MediumCardTemplate summary={productsDetailSnapshots} loading={props.fetchingPerformance} />
                        </div>
                  </section>
                  <section className="col-12 xl:col-3 product-detail-sidebar">
                        <RoleAccess roles={["OWNER", "ADMIN"]}>
                              {props.state.planGroup.status !== "ARCHIVED" &&
                                    <div id="product-detail-side-menu" className="product-detail-side-menu">
                                          <p className="action-titles">{props.t("products.quick-actions")}</p>
                                          {sideMenu.map(({ label, icon, iconClass, onclick, hasSubmenu }, index) => (
                                                <div className="side-menu-content" key={index}>
                                                      <div
                                                            ref={hasSubmenu ? addPlanTriggerRef : null}
                                                            onClick={(e) => onclick(e)}
                                                      >
                                                            <i className={`pi ${icon}${iconClass ? ` ${iconClass}` : ""}`} />
                                                            <span> {label}</span>
                                                            {hasSubmenu && <i className="pi pi-angle-right plan-add-submenu-icon" />}
                                                      </div>
                                                      {hasSubmenu && (
                                                            <CustomOverlayPanel
                                                                  op={addPlanOp}
                                                                  appendTo={document.body}
                                                                  onShow={alignAddPlanOverlayArrow}
                                                                  className="plan-create-kind-sidebar-overlay"
                                                            >
                                                                  <div className="plan-create-kind-overlay">
                                                                        {planKindItems.map((item) => (
                                                                              <div
                                                                                    key={item.wizardType}
                                                                                    className="plan-create-kind-menu-item"
                                                                                    onClick={() => {
                                                                                          navigateToPlanWizard(navigate, props.state.planGroup.id, {
                                                                                                planGroup: props.state.planGroup,
                                                                                                wizardType: item.wizardType,
                                                                                                returnTo: planCreateReturnTo,
                                                                                          });
                                                                                    }}
                                                                                    role="menuitem"
                                                                                    tabIndex={0}
                                                                                    onKeyDown={(e) => {
                                                                                          if (e.key === 'Enter' || e.key === ' ') {
                                                                                                navigateToPlanWizard(navigate, props.state.planGroup.id, {
                                                                                                      planGroup: props.state.planGroup,
                                                                                                      wizardType: item.wizardType,
                                                                                                      returnTo: planCreateReturnTo,
                                                                                                });
                                                                                          }
                                                                                    }}
                                                                              >
                                                                                    <span className="plan-create-kind-title">{item.label}</span>
                                                                                    <span className="plan-create-kind-description">{item.description}</span>
                                                                              </div>
                                                                        ))}
                                                                  </div>
                                                            </CustomOverlayPanel>
                                                      )}
                                                </div>
                                          ))}
                                          <hr className="side-menu-hr" />
                                          <p className="action-titles">{props.t("products.associated-data")}</p>

                                          {paymentSideMenu.map(({ paymentLabel, icon, ellipsisIcon }, i) => (<div key={i}>
                                                <div className="side-menu-content">
                                                      <div className="paymentSideMenu" onClick={togglePaymentsMenu}>
                                                            <i className={"pi " + icon} />
                                                            <p className="payments_p">{paymentLabel}</p>
                                                            <i id="paymentContextIcon" className={ellipsisIcon} />
                                                      </div>
                                                      <CustomOverlayPanel op={op}>
                                                            <div>
                                                                  <ul className="user-profile-items">
                                                                        <li>
                                                                              <div className="p-link list-button" onClick={() => {
                                                                                    redirectToPaymentsPage('collected')
                                                                              }}>
                                                                                    <span className="list-items">{props.t("payments.collected")}</span>
                                                                              </div>
                                                                        </li>
                                                                  </ul>
                                                                  <ul className="user-profile-items">
                                                                        <li>
                                                                              <div className="p-link list-button" onClick={() => {
                                                                                    redirectToPaymentsPage('missed')
                                                                              }}>
                                                                                    <span className="list-items">{props.t("payments.missed")}</span>
                                                                              </div>
                                                                        </li>
                                                                  </ul>
                                                                  <ul className="user-profile-items">
                                                                        <li>
                                                                              <div className="p-link list-button" onClick={() => {
                                                                                    redirectToPaymentsPage('external')
                                                                              }}>
                                                                                    <span className="list-items">{props.t("payments.external")}</span>
                                                                              </div>
                                                                        </li>
                                                                  </ul>
                                                                  <ul className="user-profile-items">
                                                                        <li>
                                                                              <div className="p-link list-button" onClick={() => {
                                                                                    redirectToPaymentsPage('accounts')
                                                                              }}>
                                                                                    <span className="list-items">{props.t("payments.collected_and_external")}</span>
                                                                              </div>
                                                                        </li>
                                                                  </ul>
                                                            </div>
                                                      </CustomOverlayPanel>
                                                </div>
                                          </div>))}
                                          {bottomSideMenu.map(({ label, icon, onclick }, i) => (
                                                <div className="side-menu-content" key={i}>
                                                      <div onClick={onclick}>
                                                            <i className={"pi " + icon} />
                                                            <span>{label}</span>
                                                      </div>
                                                </div>
                                          ))}
                                    </div>}
                        </RoleAccess>
                  </section>
            </div >
      )
}

export default ProductDetailCardInsights;